/**
 * StudentTemplate
 */

import React from 'react';
import PropTypes from 'prop-types';
import useLocaleContext from 'containers/LanguageProvider/useLocaleContext.js';
import Page from './Page.jsx';
import StudentBody from './StudentBody.js';

function StudentTemplate(props) {
  const { locale } = useLocaleContext();
  const { users, language = locale } = props;

  const pages = users.map((user) => language === 'nl' ? (
    <Page key={user.code}>
      <div className="text-end">
        {user.fullName}
        <br />
        {user.groups && user.groups.join(', ')}
      </div>
      <StudentBody>
        <h1>{`Hoi ${user.firstName}!`}</h1>
        <ol>
          <li>
            Ga naar
            <strong className="mx-2">app.socialschools.eu/leerling</strong>
            om je account te maken (Let op dat je dit goed overtypt)
          </li>
          <li>
            De activatiecode die je daar moet invullen is:
            <samp className="d-block">{user.code}</samp>
          </li>
          <li>Vraag de juf of meester om hulp als het niet lukt.</li>
        </ol>
      </StudentBody>
    </Page>
  ) : (
    <Page key={user.id}>
      <div className="text-end">
        {user.fullName}
        {user.groups.join(', ')}
      </div>
      <StudentBody>
        <h1>{`Hi ${user.firstName}!`}</h1>
        <ol>
          <li>
            Go to
            <strong className="mx-2">app.socialschools.eu/leerling</strong>
            to create your account (type the address carefully)
          </li>
          <li>
            Fill out your activation code:
            <samp className="d-block">{user.code}</samp>
          </li>
          <li>Ask your teacher if you are having trouble</li>
        </ol>
      </StudentBody>
    </Page>
  ));
  return pages;
}

StudentTemplate.propTypes = {
  users: PropTypes.array,
};

export default StudentTemplate;
